export default __webpack_public_path__ + "static/banner_back-2cad7532e00f3431839234156d14e3ee.webp";